import { HardTokenIntegrationController } from '../hard-token-integration.controller';

export class Controller extends HardTokenIntegrationController {

    /** @ngInject */
    constructor(HardTokenService) {
        super(HardTokenService);
    }

    $onInit() {
        super.$onInit();
        this.type = 'YUBIKey_USB_KEY';
        this.otpType = 'YOTP';
        this.htUsbAnimHotp= require('./hthotp.gif');
        this.htUsbAnim= require('./htusbanim.gif');
        this.tooltipTemplate = require('./tooltip.html');
        this.tooltipHotpTemplate = require('./tooltip-hotp.html');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-usb-token/integrate-usb-token.controller.js